import {COLORS} from "./constants";
import {fix_and_destroy_block} from "svelte/internal";


Date.isLeapYear = function (year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
};

Date.getDaysInMonth = function (year, month) {
    return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};

Date.prototype.isLeapYear = function () {
    return Date.isLeapYear(this.getFullYear());
};

Date.prototype.getDaysInMonth = function () {
    return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};

Date.prototype.addMonths = function (value) {
    let n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(Math.min(n, this.getDaysInMonth()));
    return this;
};


// const formatDate = (dateString, format = 'd-m-y', separator = '-') => {
//     if (!dateString) {
//         return '';
//     }
//
//     let [dateFormat, timeFormat] = format.split(' ');
//     let dt;
//
//     if (dateString instanceof Date) {
//         dt = dateString;
//     } else {
//         let [dateStr, timeStr] = dateString.split(' ');
//         if (timeFormat) {
//             dt = new Date(dateStr + " " + timeStr);
//         } else {
//             dt = new Date(dateStr);
//         }
//     }
//
//
//     let newDate = '';
//
//     if (dateFormat == 'd-m-y') {
//         newDate = `${dt.getDate()}`.padStart(2, '0') + separator +
//             `${(dt.getMonth() + 1)}`.padStart(2, '0') + separator +
//             dt.getFullYear();
//     } else {
//         newDate = dt.getFullYear() + separator +
//             `${(dt.getMonth() + 1)}`.padStart(2, '0') + separator +
//             `${dt.getDate()}`.padStart(2, '0');
//     }
//
//     if (timeFormat && timeStr) {
//         let [h, m, s] = timeStr.split(':');
//         newDate += (timeFormat == 'h:m:s' ? ` ${h}:${m}:${s}` : ` ${h}:${m}`);
//     }
//
//     return newDate;
// };

const humanDate = (date, noDay = false) => {
    if (!date) {
        return '';
    }

    let dt;
    let today = new Date();
    let days = ['Κυρ', 'Δευ', 'Τρ', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ', 'Κυρ'];
    let months = ['Ιαν', 'Φεβ', 'Μάρ', 'Απρ', 'Μάη', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Οκτ', 'Νοέ', 'Δεκ'];

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    if (today.toDateString() === dt.toDateString()) {
        return 'Σήμερα';
    }

    if (noDay) {
        return `${dt.getDate()} ${months[dt.getMonth()]}` + (dt.getFullYear() != today.getFullYear() ? ` ${dt.getFullYear()}` : '');
    }

    return `${days[dt.getDay()]}, ${dt.getDate()} ${months[dt.getMonth()]}` + (dt.getFullYear() != today.getFullYear() ? ` ${dt.getFullYear()}` : '');
}


const YMD_HMS = (date) => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    return `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())} ${pad0(dt.getHours())}:${pad0(dt.getMinutes())}:${pad0(dt.getSeconds())}`;
}

// y-m-d H:i:s
const formatDate = (date, format = 'y-m-d') => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        // date is date class
        dt = date;
    } else {
        // date is string
        // separate date and time
        let [d, t] = date.split(" ");

        let parts = d.split("-");
        if (parts.length < 3) {
            console.log("formatDate: wrong date", date, parts);
            return '';
        }
        if (parts[0].length == 4) { // year comes first
            dt = new Date(date);
        } else {
            dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}` + (t ? ` ${t}` : ''));
        }
    }

    let dateStr = '';
    for (let i = 0; i < format.length; i++) {
        if (format[i] === 'y') {
            dateStr += dt.getFullYear();
        } else if (format[i] === 'm') {
            dateStr += pad0(dt.getMonth() + 1);
        } else if (format[i] === 'd') {
            dateStr += pad0(dt.getDate());
        } else if (format[i] === 'H') {
            dateStr += pad0(dt.getHours());
        } else if (format[i] === 'i') {
            dateStr += pad0(dt.getMinutes());
        } else if (format[i] === 's') {
            dateStr += pad0(dt.getSeconds());
        } else {
            dateStr += format[i];
        }
    }
    return dateStr;
}

const getDate = (format = 'y-m-d') => {
    let dt = new Date();

    return formatDate(dt, format);
}

const millisecondsToHours = (milliseconds) => {
    let seconds = Math.floor(Math.abs(milliseconds) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    // hours = hours % 24;
    return `${hours}`.padStart(2, '0') + ':' + `${minutes}`.padStart(2, '0') + ':' + `${seconds}`.padStart(2, '0');
}

const millisecondsToArray = (milliseconds) => {
    let seconds = Math.floor(Math.abs(milliseconds) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    // hours = hours % 24;
    return [`${hours}`.padStart(2, '0'), `${minutes}`.padStart(2, '0'), `${seconds}`.padStart(2, '0')];
}

const durationString = (milliseconds) => {
    let seconds = Math.floor(Math.abs(milliseconds) / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    let str = '';
    if (hours > 0) {
        return `${hours}h` + (minutes > 0 ? `${minutes}m` : '');
    } else {
        return (minutes > 0 ? `${minutes}m` : '') + `${seconds}s`;
    }
}

const getWeeksDiff = (startDate, endDate) => {

    const msInWeek = 1000 * 60 * 60 * 24 * 7;
    return Math. round(Math. abs(endDate - startDate) / msInWeek);
}

const getMonthsDiff = (startDate, endDate) => {
    let sdt = new Date(startDate);
    let edt = new Date(endDate);
    let difference = (edt.getFullYear()*12 + edt.getMonth()) - (sdt.getFullYear()*12 + sdt.getMonth());

    return difference;
}

const pad0 = x => x.toString().padStart(2, "0");

const getTimeFromDate = (dateString) => {
    if (!dateString) {
        return '';
    }

    let datetime = dateString.split(" ");
    return datetime[1] || '';
}


const copyObject = obj => {
    return JSON.parse(JSON.stringify(obj));
};

const sort = (array, key, descending) => {
    if (descending) {
        return array.sort((a, b) => (a[key] < b[key] ? 1 : -1));
    }

    return array.sort((a, b) => (a[key] > b[key] ? 1 : -1));
}

const setFocusTo = (element_id, delay = 280) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, delay);
    }
}

const setFocusOut = (element_id) => {
    if (!element_id) {
        return;
    }

    let element = document.getElementById(element_id);
    if (element) element.blur();
};

const upCaseStr = str => {
    if (!str) {
        return "";
    }
    let arr = [['Ά', 'Α'], ['Έ', 'Ε'], ['Ή', 'Η'], ['Ί', 'Ι'], ['Ϊ', 'Ι'], ['Ό', 'Ο'], ['Ύ', 'Υ'], ['Ϋ', 'Υ'], ['Ώ', 'Ω']];
    str = str.toUpperCase();
    arr.map(chars => {
        str = str.split(chars[0]).join(chars[1]);
    });
    return str;
}


const acronym = str => {
    if (!str) {
        return '';
    }
    let arr = str.toUpperCase().match(/\b(\w)/g);
    if (!arr) {
        return str[0];
    }
    return arr.join('');
}


const randomColor = () => {
    let color = Math.floor(Math.random() * (COLORS.length - 1));
    return COLORS[color];
}

const validateFormData = (obj, data) => {
    let error = null;

    let index = 0;
    while (index < data.length) {
        let item = data[index];
        if (validateField[item.validation](obj[item.field])) {
            error = {field: item.field, message: item.message};
            index = data.length;
        }
        index++;
    }

    return error;
}

const validateField = {
    is_empty: (value) => {
        if (typeof value === 'string' || value instanceof String) {
            return !value.trim();
        } else if (Array.isArray(value)) {
            return !value.length;
        } else {
            return value === null;
        }

        return false;
    },

    is_number: value => {
        return !value || typeof ~~value !== 'number';
    }
}

const findNode = (id, array) => {
    let node = null;
    node = array.find(x => x.id == id);
    if (!node) {
        array.map(item => {
            if (!node && item.children && item.children.length) {
                node = findNode(id, item.children);
            }
        })
    }
    return node;
}

export {
    pad0,
    humanDate,
    formatDate,
    getDate,
    YMD_HMS,
    millisecondsToHours,
    millisecondsToArray,
    durationString,
    getWeeksDiff,
    getMonthsDiff,
    getTimeFromDate,
    copyObject,
    sort,
    setFocusTo,
    setFocusOut,
    upCaseStr,
    acronym,
    randomColor,

    validateFormData,
    findNode,
}